var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-warp"},[_c('screen',{ref:"screen",attrs:{"clickUpate":true,"showBtns":false,"options":_vm.screenOptions},on:{"updateOptions":_vm.updateOptions,"confirm":_vm.filterChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }